import { useEffect, useRef } from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  Backdrop,
  Fade,
} from "@mui/material";
import { LuInfo } from "react-icons/lu";
import { AiFillCloseCircle } from "react-icons/ai";
import { START_FINBOX_FLOW_LOCAL_KEY } from "../../Constants/constant";


export default function LoanRejectModal({open, onClose}) {
  const isFirstRender = useRef(true);

  useEffect(() => { 
    return () => {
       if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }
      console.log("LoanRejectModal unmounted, removing localStorage key");
      localStorage.removeItem(START_FINBOX_FLOW_LOCAL_KEY);
    }
  }, []);

  return (
    <>

      <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 400,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 380,
              bgcolor: "background.paper",
              borderRadius: 3,
              boxShadow: 24,
              p: 3,
              outline: "none",
               borderRadius: 4,    
                maxWidth: "95%",
            }}
          >
            {/* Top Icons Row */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 1,
              }}
            >
              <LuInfo size="50" color="#fb4d52" />
              <IconButton onClick={onClose} sx={{
                position:"absolute",
                right: 14,
                top: 14,
                padding: 0,
              }}> 
                <AiFillCloseCircle size={25} color="#D1D1D1" />
              </IconButton>
            </Box>

            {/* Content */}
            <Typography align="center" variant="h6" sx={{ mb: 1, fontWeight: 500, fontSize: '16px', fontFamily: 'inherit' }}>
            You’re not eligible for the <br/>12-month loan
            </Typography>
            <Typography component={'div'} align="center" variant="body2" sx={{ fontSize: '13px', fontFamily: 'inherit' }}>
            No worries! You can still choose from the <br/><Typography fontWeight={600} sx={{ fontFamily: 'inherit' }}>Other Loan Options</Typography>
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <img width="115"  src="/images/ramfincorp_logo.svg" />
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
